<template>
	<div class="upload-img">
		<el-upload
		  :action="uploadUrl"
		  list-type="picture-card"
		  accept=".png, .jpeg, .jpg, .gif"
		  :multiple="multiple"
		  :on-preview="handlePictureCardPreview"
		  :on-exceed="handleExceed"
		  :before-upload="beforeUpload"
		  :on-success="handleSuccess"
		  :on-remove="handleRemove"
		  :limit = "limit"
		  >
		  <i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible">
		  <img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
	import { post, config, ajaxParam } from '@/units/request.js'
	export default {
		name: 'uploadImg',
		components: {},
		props: {
			limit: {
				type: Number,
				value: '9'
			},
			multiple:{
				type: Boolean,
				value: true
			}
		},
		data() {
			return {
				dialogImageUrl: '',
				dialogVisible: false,
				uploadUrl: '',
				uploadFileList: [],
			}
		},
		created(){
			this.uploadUrl = config.baseUrl + 'v1/upload/pic'
		},
		methods: {
			beforeUpload(file){
				const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1)
				const whiteList = ['jpg', 'jpeg', 'png', 'gif']
				if (whiteList.indexOf(fileSuffix) == -1) {
					this.$message.error("请上传图片格式")
					return false
				}
			},
			handleSuccess(res, file, fileList){
				// this.uploadFileList = fileList
				// this.$emit('uploadSuccess',{
				// 	uploadFileList: this.uploadFileList
				// })
				this.uploadFileList.push(res.entity.fileUrl)
				this.$emit('uploadSuccess',{
					uploadFileList: this.uploadFileList
				})
			},
			handleRemove(file, fileList) {
				this.uploadFileList = fileList
				this.$emit('uploadDelete',{
					uploadFileList: this.uploadFileList
				})
			},
			handleExceed(){
				this.$message.error(`最多上传${this.limit}张图片`)
			},
			handlePictureCardPreview(file) {
				console.log('333333')
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			}
		}
	}
</script>

<style scoped lang="less">
	.upload-img{
		margin-bottom: 20px;
	}
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	  .avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	  }
</style>
